import { z } from 'zod'

export const PasswordSchema = z
	.string({ error: 'Password is required' })
	.min(6, { error: 'Password is too short' })
	.max(72, { error: 'Password is too long' }) // bcrypt has a limit of 72 characters
export const NameSchema = z
	.string({ error: 'Name is required' })
	.min(3, { error: 'Name is too short' })
	.max(40, { error: 'Name is too long' })
export const EmailSchema = z
	.string({ error: 'Email is required' })
	.email({ error: 'Email is invalid' })
	.min(3, { error: 'Email is too short' })
	.max(100, { error: 'Email is too long' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'The passwords must match',
			})
		}
	})
